<template>
    <div>
        <Header page-type="manage">
            <template v-slot:menu_left>
                <router-link v-if="isBrandManager || isOtherManager" :to="{ name: 'manageStoredSelect' , params: { brandPath: $route.params.brandPath } }">
                    <div class="icn_green">＜戻る</div>
                </router-link>
                <router-link v-else :to="{ name: 'top' , params: { brandPath: $route.params.brandPath } }">
                    <div class="icn_green">＜戻る</div>
                </router-link>
            </template>
            <template v-slot:menu_center>
                <p class="menu_center_tex_l">報告書一覧</p>
            </template>
        </Header>
        <Calendar ref="calendar"/>
    </div>
</template>

<script>

    // @ is an alias to /src
    import Header from '@/app/components/Header.vue'
    import Calendar from '@/app/components/Calendar.vue'

    export default {
        name: 'ReportMonthly',
        components: {
            Header,
            Calendar
        },
        data: function () {
            return {
                auth:'',
            }
        },
        created: function(){
            this.auth = this.$store.getters['manager/manager'].authorityKbn;
        },
        computed:{
            isBrandManager: function () {
                return this.auth == 2
            },
            isOtherManager: function () {
                return this.auth == 6
            }
        }
    }
</script>
